import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=1dcfa480&scoped=true"
import script from "./AddBalance.vue?vue&type=script&lang=js"
export * from "./AddBalance.vue?vue&type=script&lang=js"
import style0 from "./AddBalance.vue?vue&type=style&index=0&id=1dcfa480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcfa480",
  null
  
)

export default component.exports